import CustomerOffer from './CustomerOffer'

export default CustomerOffer
